import { ChevronRight } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';

interface IProps {
    icon: React.ReactNode;
    title: string;
    onClick: () => void;
}

const ActionCard = ({ icon, title, onClick }: IProps) => (
    <div
        onClick={onClick}
        className="max-w-[86%] ai-sender flex items-center gap-x-2 p-3 border border-utilityGray200 rounded-[10px] bg-white cursor-pointer hover:bg-gray50 transition-colors duration-200"
    >
        <figure className="w-4 h-4 text-grayLight600">{icon}</figure>
        <p className="flex-1 text-xs font-medium text-textSecondary truncate">{title}</p>
        <ChevronRight className="flex-none w-4 h-4 text-textSecondary" />
    </div>
);

export default ActionCard;
